import React from 'react'
import { Modal, ModalBody } from 'uiComponents/popups/modal.new'
import './cancelMembershipModal.scss'
import { MembershipDetailed } from 'memberships/schema'
import PressAndHoldButton from 'uiComponents/buttons/pressAndHoldButton'
import ActionButton from 'uiComponents/buttons'
import 'uiComponents/buttons/styles/cancelButton.scss'
import { DateFormats, formatISOString } from 'utils'

interface CancelMembershipModalProps {
    membership: MembershipDetailed
    onCancelMembership: () => void
    onDisableAutoRenewal: () => void
    onClose: () => void
}

export const CancelMembershipModal: React.FC<CancelMembershipModalProps> = ({
    membership,
    onCancelMembership,
    onDisableAutoRenewal,
    onClose,
}) => {
    const title = membership.autoRenewEnabled ? 'Disable automatic renewal or cancel membership?' : 'Cancel membership'
    const expiresAtString = formatISOString(membership.expiresAt, DateFormats.EXTRA_LONG_DATE)

    const handleCancelMembership = async () => {
        await onCancelMembership()
        onClose()
    }

    const handleDisableAutoRenewal = async () => {
        await onDisableAutoRenewal()
        onClose()
    }

    return (
        <Modal className="cancel-membership-modal" title={title} onDismiss={onClose}>
            <ModalBody>
                {membership.autoRenewEnabled && (
                    <div className="option disable-auto-renew">
                        <div className="option-title">Disable auto-renew</div>
                        <ul>
                            <li>The membership will expire on {expiresAtString}.</li>
                            <li>
                                {membership.billing.paymentSchedule === 'P1M'
                                    ? 'Monthly payments will continue until that date.'
                                    : 'There are no outstanding payments until the expiry date.'}
                            </li>
                            <li>
                                {membership.member?.firstName ?? 'The member'} can continue visiting until the
                                membership expires.
                            </li>
                        </ul>
                        <ActionButton className="cancel-button" onClick={handleDisableAutoRenewal}>
                            Disable auto-renew
                        </ActionButton>
                    </div>
                )}
                <div className="option cancel-membership">
                    <div className="option-title">End membership immediately</div>
                    <ul>
                        <li>Membership access will end immediately.</li>
                        <li>Any remaining payments will be waived.</li>
                        <li>{membership.member?.firstName ?? 'The member'} will no longer be able to visit.</li>
                    </ul>
                    <PressAndHoldButton
                        text="End membership immediately"
                        holdTime={3000}
                        onComplete={handleCancelMembership}
                        destructive
                    />
                </div>
            </ModalBody>
        </Modal>
    )
}
